// Appels HTTP typés vers /api/audit-events — consultation du journal d'audit
// du tenant courant (Lot 6C). ADMIN-only côté backend, on n'affiche pas non
// plus la page aux autres rôles côté UI.

import { api } from "./client";
import type { UUID } from "./types";

/** Les 7 actions tracées — alignées sur AuditAction côté back. */
export type AuditAction =
  | "session_started"
  | "member_invited"
  | "member_added_direct"
  | "invitation_revoked"
  | "invitation_accepted"
  | "member_role_changed"
  | "member_removed";

export type AuditActorPublic = {
  id: UUID;
  email: string;
  full_name: string;
};

export type AuditEventPublic = {
  id: UUID;
  action: AuditAction;
  actor: AuditActorPublic | null;
  target_type: string | null;
  target_id: UUID | null;
  /** JSON libre — `{ "via": "login" }`, `{ "old_role": "comptable", ... }`, etc. */
  metadata: Record<string, unknown>;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string; // ISO
};

export type AuditEventPage = {
  items: AuditEventPublic[];
  total: number;
  limit: number;
  offset: number;
};

export type ListAuditEventsParams = {
  limit?: number;
  offset?: number;
  action?: AuditAction;
};

function buildQuery(params: ListAuditEventsParams): string {
  const search = new URLSearchParams();
  if (params.limit !== undefined) search.set("limit", String(params.limit));
  if (params.offset !== undefined) search.set("offset", String(params.offset));
  if (params.action !== undefined) search.set("action", params.action);
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

export const auditApi = {
  list: (params: ListAuditEventsParams = {}) =>
    api.get<AuditEventPage>(`/api/audit-events${buildQuery(params)}`),
};
